module.exports = __webpack_public_path__ + "img/influencer-visit.dd7aeb9f.jpg";